import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import LogoFooter from "../assets/img/full logo white blue.svg";

const FooterComponent = () => {
  return (
    <div>
      <footer id="footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6 footer-info">
                <img src={LogoFooter} alt="Curigma logo"></img>
                <br />
                <p>
                  www.curigma.in <br />
                  Bhubaneswar,India <br />
                  <strong>MSME:</strong> UDYAM-OD-05-0004571
                  <br />
                  <br />
                  {/* <strong>Phone:</strong> +1 5589 55488 55 */}
                  <br />
                  <strong>Email:</strong> contact@curigma.in
                  <br />
                </p>
                <div className="social-links mt-3">
                  <a
                    href="https://www.facebook.com/CurigmaTechnologies"
                    className="facebook"
                  >
                    <FaFacebook />
                  </a>
                  <a href="https://twitter.com/CurigmaT" className="twitter">
                    <FaXTwitter />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/curigma-technologies"
                    className="linkedin"
                  >
                    <FaLinkedin />
                  </a>
                </div>
              </div>
              <div className="col-lg-2 col-md-6 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/service">Services</Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/about">About us</Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/product">Product</Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/contact">Contact</Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-6 footer-links">
                <h4>Our Services</h4>
                <ul>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/service">Mobile Applications</Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/service">Web Development</Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/service">IOT Product Management</Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/service">Digital Marketing</Link>
                  </li>
                  <li>
                    <i className="bx bx-chevron-right"></i>{" "}
                    <Link to="/service">Graphic Design</Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-4 col-md-6 footer-newsletter">
                <h4>Our Newsletter</h4>
                <p></p>
                <form action="" method="post">
                  <input type="email" name="email" />
                  <input type="submit" value="Subscribe" />
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="copyright">
            &copy; Copyright{" "}
            <strong>
              <span>Curigma</span>
            </strong>
            . All Rights Reserved
          </div>
          <div className="credits">
            Designed by <a href="http://Curigma.in/">Curigma Technologies</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FooterComponent;
